export default __webpack_public_path__ + "static/media/search-property.da6f084e.svg";